"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackagingSetSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class PackagingSetSearchResponse extends common_1.PaginatedResponse {
}
exports.PackagingSetSearchResponse = PackagingSetSearchResponse;
//# sourceMappingURL=packaging-set-search.response.js.map